import { useContext, useEffect, useState } from 'react';
// import * as React from 'react';
// import { styled } from "@mui/material/styles";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
// import { ActionButton } from "@mui/material";
import colors from '../../essentials/colors';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { Card, CardActions } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
//importing image
import agent from '../../assets/agents.jpeg';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SnoozeIcon from '@mui/icons-material/Snooze';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import ClientrdContext from '../../context/clientrd/clientrdContext';

import EditSharpIcon from '@mui/icons-material/EditSharp';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import Spinner from '../layout/Spinner';

const LabelButton = styled(Button)`
    && {
        background-color: ${colors.orange};
    }
`;

const AgentDescription = (props) => {
    let navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const { user, isAuthenticated } = authContext;
    const [deletee, setDeletee] = useState(false);
    const clientrdContext = useContext(ClientrdContext);
    const { clientrds, getClientrds, updateClientrd, deleteClientrd } =
        clientrdContext;

    useEffect(() => {
        !isAuthenticated ? navigate('/login') : null;
    }, []);

    const onClickPaymentTrans = () => {
        navigate('/paymentsummary');
    };
    const onClickClient = () => {
        navigate('/allclients');
    };
    const location = useLocation();
    let agent = location.state;
    const deletePayment = async (id) => {
        await deleteClientrd(id);
        setDeletee(false);
        onClickPaymentTrans();
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
                <Grid item xs={12} md={12} ml={4}>
                    <Typography variant="h3" mb={4}>
                        Client Information
                    </Typography>
                </Grid>
            </Grid>

            <Grid
                container
                pl={5}
                pr={5}
                col={12}
                justifyContent="space-around"
            >
                {/* <Grid item xs={12} md={3} mb={2}>
                    <Card sx={{ maxWidth: 345 }}>
                        <CardMedia
                            component="img"
                            height="190"
                            image={agent.photo}
                            alt="agent-pic"
                        />
                        <CardActions>
                            <label htmlFor="icon-button-file">
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    component="span"
                                >
                                </IconButton>
                            </label>
                        </CardActions>
                    </Card>
                </Grid> */}

                <Grid item xs={12} md={12}>
                    <Grid
                        container
                        justifyContent="space-aroud"
                        alignItems="center"
                        spacing={1}
                    >
                        <Grid item xs={6} md={3}>
                            <h3>Name: </h3>
                        </Grid>
                        <Grid item xs={6} md={9}>
                            {agent.name}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <h3>Address: </h3>
                        </Grid>
                        <Grid item xs={6} md={9}>
                            {agent.address}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <h3>Pan No. : </h3>
                        </Grid>
                        <Grid item xs={6} md={9}>
                            {agent.pan}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <h3>Contact No. : </h3>
                        </Grid>
                        <Grid item xs={6} md={9}>
                            {agent.contact}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <h3>Email id : </h3>
                        </Grid>
                        <Grid item xs={6} md={9}>
                            {agent.email}
                        </Grid>
                        <Grid>
                            <IconButton
                                size="large"
                                aria-label="Clientform"
                                style={{ color: 'black' }}
                                onClick={() => {
                                    navigate('/clientform', {
                                        state: agent
                                    });
                                }}
                            >
                                <EditSharpIcon />
                                <Typography
                                    variant="body2"
                                    align="center"
                                ></Typography>
                            </IconButton>

                            <IconButton
                                size="large"
                                aria-label="Clientform"
                                style={{ color: 'darkred' }}
                                onClick={(async) => {
                                    setDeletee(true);

                                    deletePayment(agent?._id);
                                }}
                            >
                                {deletee == true ? (
                                    <Spinner
                                        style={{
                                            height: '20px',
                                            width: '60px'
                                        }}
                                    />
                                ) : (
                                    <DeleteSharpIcon />
                                )}

                                <Typography
                                    variant="body2"
                                    align="center"
                                ></Typography>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid
                container
                spacing={1}
                mt={2}
                alignItems="center"
                justifyContent="space-around"
            >
                <Grid item xs={20} md={4}>
                    <LabelButton fullWidth={true} onClick={onClickClient}>
                        <Typography color="white" p={4}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                }}
                            >
                                <DescriptionIcon /> <p>All Client's List</p>
                            </div>
                        </Typography>
                    </LabelButton>
                </Grid>
                <Grid item xs={20} md={4}>
                    <LabelButton fullWidth={true} onClick={onClickPaymentTrans}>
                        <Typography color="white" p={4}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                }}
                            >
                                <ReceiptIcon />
                                <p>Transactions</p>
                            </div>
                        </Typography>
                    </LabelButton>
                </Grid>
                {/* <Grid item xs={12} md={3}>
                    <LabelButton
                        fullWidth={true}
                        onClick={onClickNotifications}
                    >
                        <Typography color="white" p={4}>
                            <SnoozeIcon /> Notifications
                        </Typography>
                    </LabelButton>
                </Grid> */}
            </Grid>
        </Box>
    );
};

export default AgentDescription;
